import React from "react";

import HomeBaseBanner from "@/mk2/apps/home/components/HomeBaseBanner";
import { UserEntity } from "@/mk2/schemas";
import {
    PREGNANCY_NEWSLETTER_BANNER_TEXT,
    PREGNANCY_NEWSLETTER_HINT,
} from "@/mk/autogenerated/translations/HomeBaseBannerComponent.d4851c861702d8a91512fc79d3310573";
import { ACTIVE_SERVER_ID, BASE_URL } from "@/mk/settings";

interface OwnProps {
    className?: string;
    requestUser?: UserEntity;
    showPregnancyNl?: boolean;
}

type Props = OwnProps;

const HomeBaseBannerComponent = React.memo<Props>(
    ({ className, requestUser, showPregnancyNl = true }) => {
        const pregnancyNLLink = {
            201: `${BASE_URL}/som-tehotna/newsletter-pre-tehotne/?utm_source=modrykonik&utm_medium=titulka&utm_content=pevna_pozicia&utm_campaign=newsletter`,
            202: `${BASE_URL}/jsem-tehotna/newsletter-pro-tehotne/?utm_source=modrykonik&utm_medium=titulka&utm_content=pevna_pozicia&utm_campaign=newsletter`,
        }[ACTIVE_SERVER_ID];

        return (
            <>
                {showPregnancyNl && (
                    <HomeBaseBanner
                        className={className}
                        linkTo={pregnancyNLLink}
                        text={PREGNANCY_NEWSLETTER_BANNER_TEXT}
                        hintText={PREGNANCY_NEWSLETTER_HINT}
                    />
                )}
            </>
        );
    },
);

HomeBaseBannerComponent.displayName = "HomeBaseBannerComponent";

export default HomeBaseBannerComponent;
